import { CommonModule } from '@angular/common';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { ScanQROrderFacade } from './+state';
import { ScanQROrderStateModule } from './+state/scan-qr-order.state.module';

import {
  ScanQROrderService
} from './services';

@NgModule({
  imports: [CommonModule, ScanQROrderStateModule],
})
export class DomainScanQROrderModule {
  public static forRoot(): ModuleWithProviders {
    return {
      ngModule: DomainScanQROrderModule,
      providers: [
        ScanQROrderService,
        ScanQROrderFacade
      ],
    };
  }
}
